export default function PageHero({ kicker, title, image }) {
  return (
    <section className="relative h-[46vh] min-h-[340px] w-full overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center animate-kenburns"
        style={{ backgroundImage: `url(${image})` }}
      />
      <div className="absolute inset-0 bg-[#0f6b82]/55" />
      <div className="absolute inset-0 bg-gradient-to-b from-black/10 to-black/30" />
      <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-6">
        {kicker && (
          <p className="font-heading text-white/90 text-sm uppercase tracking-[0.4em] mb-4 animate-fade-up">
            {kicker}
          </p>
        )}
        <h1
          className="font-heading text-white text-4xl md:text-6xl font-light uppercase tracking-[0.06em] max-w-4xl animate-fade-up"
          style={{ animationDelay: "0.12s" }}
        >
          {title}
        </h1>
      </div>
    </section>
  );
}
